import { css } from "../../../theme/util/helpers";

export const quoteStyling = css`
    blockquote {
        /* margin: 0; */
    }
`;

export default quoteStyling;
